<template>
  <div
    @click="e => this.$emit('click', e)"
    class="app-list-item"
    :class="{
      active,
      'no-padding': noPadding,
      'with-border': withBorder,
      column: direction === 'column',
      disabled,
    }"
    :style="{ width: `${itemWidthPercentage}%` }"
  >
    <slot />
  </div>
</template>

<script>
export default {
  name: 'AppListItem',

  props: {
    direction: {
      type: String,
      default: 'row',
    },

    active: {
      type: Boolean,
      default: false,
    },

    disabled: {
      type: Boolean,
      default: false,
    },

    noPadding: {
      type: Boolean,
      default: false,
    },

    withBorder: {
      type: Boolean,
      default: false,
    },
  },

  computed: {
    list() {
      return this.$parent
    },

    itemWidthPercentage() {
      const list = this.list

      // return list.grid ? 100 / list.columns : 100
    },
  },
}
</script>

<style lang="scss" scoped>
@use 'sass:math';

@import '@/styles/settings.scss';

.app-list-item {
  display: flex;
  align-items: center;
  padding: #{math.div($defaultPadding, 2)} $defaultPadding;
  margin: 0;
  gap: 1.25rem;

  &.no-padding {
    padding: 0;
  }

  &.with-border {
    border-top: 1px solid rgba(0, 0, 0, 0.12);
  }

  &.column {
    flex-direction: column;
    margin: 0.5rem;

    .app-list-item-image {
      margin-right: 0;
      margin-bottom: 0.5rem;
    }

    .app-list-item-content {
      display: flex;
      flex-direction: column;
      align-items: center;
      margin-left: 0;
    }

    > * {
      margin-left: 0;
    }
  }
}
</style>
